import { Label, Tooltip } from "flowbite-react";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { TextInput } from "../../../../components";

/**
 * Reusable credential field component for integration forms
 */
export const CredentialField = ({
  id,
  label,
  tooltip,
  type = "text",
  placeholder,
  value,
  onChange,
  error,
}) => {
  return (
    <div>
      <div className="flex items-center gap-2">
        <Label htmlFor={id}>{label}</Label>
        {tooltip && (
          <Tooltip content={tooltip}>
            <HiQuestionMarkCircle className="h-4 w-4 text-gray-400" />
          </Tooltip>
        )}
      </div>
      <TextInput
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        color={error ? "failure" : undefined}
        helperText={error}
        className="mt-1"
      />
    </div>
  );
};
